module.exports = __webpack_public_path__ + "static/superior-logo-3c153525aa9bd29fcd74c48310ea00f5.png";